var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"logout"}},[_c('h1',{staticClass:"pt-4 mb-3"},[_vm._v("ご利用ありがとうございました。")]),(_vm.isTokenExist)?_c('a',{staticClass:"body-1",attrs:{"href":_vm.printLoginUrl}},[_vm._v("ログイン画面に戻る")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }